<template>
<div>
	<div class="text-center logo">
		<img :src="stylePathToLogo || '/static/img/logo/logo.png'" />
		<br><br>
	</div>
	<div class="w5-error-page">
		<div class="text-center">
			<h1>{{ 'error/under_construction_title' | ftc }}</h1>
			<div style="width: 100%"><Clock /></div>
			<br>
			<p v-withSafeTags="localeFtc('error/under_construction')"></p>
		</div>
	</div>
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Clock from '@/components/elements/clock'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'error503',
	//=========================================================================
	// данные переданные родителем
	//=========================================================================
	props: ['response'],
	//=========================================================================
	// данные
	//=========================================================================
	data() {
		return {
			errorCode: 0
		}
	},
	//=========================================================================
	// создание
	//=========================================================================
	created() {
		// запомним текущий код
		let _code = this.$store.state.errorHttpCode
		// сразу сбросим код ошибки в хранилище
		this.$store.commit('errorHttpCode', 0)

		// если задали данные для ошибки или код ошибки
		if (this.response || _code)
		{
			// запоминаем код
			this.errorCode = _code > 0 ? _code : this.response.status
		}
		else
		{
			// это значит пришли по прямой ссылке - делаем редирект на главную
			this.$router.push('/')
		}
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		Clock
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// error503.vue?3854b071